module.exports = __webpack_public_path__ + "static/img/cns-2.a08a4da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cns-2.jpg
// module id = kTlw
// module chunks = 0